// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"a3dd8867","787":"9629a9e8"}[chunkId] + ".chunk.js";
};